/**
 * 单据管理接口api
 */
 import { msiRequest } from "../../index";
 import { ResultType,delType } from "../../types";
 import qs from 'qs'
 
 //api接口枚举
 enum WareHoseEnum {
     ENTRYORDER_PAGE = '/WarehousOrder/page', //订单件入库单
     ENTRYORDER_ADD = '/WarehousOrder/add',
     ENTRYORDER_EDIT = '/WarehousOrder/edit',
     ENTRYORDER_DELETE = '/WarehousOrder/delete',
     INVENTORY_PAGE = '/inventory/container/query', // 无单出入库_库存管理——列表
     INVENTORY_CREATE = '/delivery/order/add', // 无单入库_库存管理——创建出库单
     OUT_PAGE = '/delivery/order/query', // 无单出入库_无单出库管理——出库单列表
     OUT_DETAIL_PAGE = '/delivery/order/detail/query',
     DEL_OUT_ORDER = '/delivery/order/delete',
     ENTRY_NO_ORDER_PAGE = '/WareManualOrders/page', //无单入库
     ENTRY_NO_ORDER_DEL = '/WarehousOrder/delete',
     ENTRY_NO_ORDER_ADD = '/WarehousOrder/add',
     ENTRY_NO_ORDER_EDIT = '/WarehousOrder/edit',
     ENTRY_NO_ORDER_DETAIL = '/WarehousOrder/pageDetails',
     ENTRY_NO_ORDER_NO = '/CriterionEnterWare/getOrderNo',
     ENTRY_NO_ORDER_MATERIAL = '/CriterionEnterWare/getMaterialDetailsPage',
     GET_WARE_Site = '/WareSite/page',
     CONFIRM_ENTRY = '/CriterionEnterWare/addWarehouseEstablishment',
     CONTAINER_LIST = '/CriterionEnterWare/getContainerDetails',
     OUTER_CONFIRM = '/task/issue',
     TASK_PAGE = '/task/query', //任务管理
     TASK_DEL = '/task/delete',
     TASK_STOP = '/task/stop',
     TASK_CONTINUE = '/task/continue',
     TASK_FINISH = '/task/finished',
     PURCHASE_PAGE = '/PurchaseOrder/page', //采购单
     PURCHASE_DETAIL = '/PurchaseOrder/pageDetails',
     PURCHASE_DELETE = '/PurchaseOrder/delete',
     PURCHASE_TEMPLATE = '/PurchaseOrder/downloadTemplate',
     PURCHASE_ADD = '/PurchaseOrder/add',
     PURCHASE_ISSUE = '/PurchaseOrder/updateStatus',
     PURCHASE_IMPORT = '/PurchaseOrder/import',
     PURCHASE_SAP = '/PurchaseOrder/addSap',
     OUT_TAMPLATE = '/delivery/order/template/download', //出库单模板下载
     OUT_DELETE = '/delivery/order/delete',
     OUT_MATERIALINFO = '/inventory/material/query', //物料库存列表
     OUT_EDIT  = '/delivery/order/detail/edit', //有单出库 --- 创建出库单
     CLAIM_PAGE = '/sorting/order/query', //分拣单管理
     ClAIM_DETAILS = '/sorting/order/detail/query',
     CLAIM_CREATE = '/sorting/order/add',
     RECEIVE_PAGE = '/delivery/order/detail/queryOrderType',
     RECEIVE_MATERIALS = '/inventory/material/queryOrderType',
     //AGV站点管理
     AGV_PAGE = '/WareSite/page', //订单件入库单
     AGV_ADD = '/WareSite/add',
     AGV_EDIT = '/WareSite/delete',
     AGV_DELETE = '/WareSite/edit',
     //AGV任务列表
     WareAGV_PAGE = '/WareAgvTask/Page', 
     WareAGV_update = '/Agv/UpdateAgvState', 
     WareAGV_delete = '/WareAgvTask/delete', 
     
 }
//分拣单 --- 分拣单列表
export function getClaimPage(data: any = {}) {
    return msiRequest.get<ResultType<any>>({
        url: `${WareHoseEnum.CLAIM_PAGE}?${qs.stringify(data)}`
    });
}

//分拣单 --- 分拣单明细
export function getClaimDetailPage(data: any = {}) {
    return msiRequest.get<ResultType<any>>({
        url: `${WareHoseEnum.ClAIM_DETAILS}?${qs.stringify(data)}`
    });
}

//分拣单------创建
export function createClaim(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.CLAIM_CREATE,
        data
    });
}


//  ----------------取货单管理--------------------------------
 //出库单 -- 编辑
 export function editOut(data: any[]) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.OUT_EDIT,
        data
    })
}

 //出库单 --- 物料库存列表
export function getExitsMaterial(data: any = {}) {
    return msiRequest.get<ResultType<any>>({
        url: `${WareHoseEnum.OUT_MATERIALINFO}?${qs.stringify(data)}`
    });
}

//领用借用物料存库列表
export function getExitsMaterials(data: any = {}) {
    return msiRequest.get<ResultType<any>>({
        url: `${WareHoseEnum.RECEIVE_MATERIALS}?${qs.stringify(data)}`
    });
}

//出库单 -- 模板下载
export function templateOut() {
    return msiRequest.post<BlobPart>({
        url: WareHoseEnum.OUT_TAMPLATE,
        responseType: 'blob'
    })
}

//出库单(有单) -- 删除
export function delOut(data: {orderNo: string[]}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.OUT_DELETE,
        data
    })
}

//  -----------------------------------------------------------------
//采购单 -- 下发
export function getSapPurchase() {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.PURCHASE_SAP
    })
}

 //采购单 -- 下发
export function editIssue(data: delType) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.PURCHASE_ISSUE,
        data
    })
}

//采购单 -- 新增、编辑
export function addPurchase(data: any={}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.PURCHASE_ADD,
        data
    })
}

 //采购单 -- 模板下载
export function templatePurchase() {
    return msiRequest.post<BlobPart>({
        url: WareHoseEnum.PURCHASE_TEMPLATE,
        responseType: 'blob'
    })
}

//采购单 -- 删除
export function delPurchase(data: delType) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.PURCHASE_DELETE,
        data
    })
}

//采购单 --- 采购单列表
export function getPurchasePage(data: any = {}) {
    return msiRequest.get<ResultType<any>>({
        url: `${WareHoseEnum.PURCHASE_PAGE}?${qs.stringify(data)}`
    });
}

//采购单 --- 采购单详情列表
export function getPurchaseDetail(data: any = {}) {
    return msiRequest.get<ResultType<any>>({
        url: `${WareHoseEnum.PURCHASE_DETAIL}?${qs.stringify(data)}`
    });
}

//  ----------------------------------------------------------
//任务管理 --- 获取任务列表
export function getTaskPage(data: any = {}) {
    return msiRequest.get<ResultType<any>>({
        url: `${WareHoseEnum.TASK_PAGE}?${qs.stringify(data)}`
    });
}

//任务管理 -- 删除任务
export function delTask(data: {taskNo: string}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.TASK_DEL,
        data
    })
}

//任务管理 -- 暂停任务
export function stopTask(data: {taskNo: string}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.TASK_STOP,
        data
    })
}

//任务管理 -- 继续任务
export function continueTask(data: {taskNo: string}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.TASK_CONTINUE,
        data
    })
}

//任务管理 -- 强制完成
export function finishTask(data: {taskNo: string}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.TASK_FINISH,
        data
    })
}
// ------------------------------------------------
//无单入库 -- 获取空容器
export function getContainerList() {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.CONTAINER_LIST
    })
}

//无单入库 -- 入库
export function confirmEntrySite(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.CONFIRM_ENTRY,
        data
    })
}

//无单入库-获取所有站点
export function getWareSite(data: any = {}) {
    return msiRequest.get<ResultType<any>>({
        url: `${WareHoseEnum.GET_WARE_Site}?${qs.stringify(data)}`
    });
}

 //无单入库-获取入库单号
export function getNoOrderNo() {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.ENTRY_NO_ORDER_NO
    });
}

//无单入库-入库单详情列表
export function getNoOrderDetail(data: any = {}) {
    return msiRequest.get<ResultType<any>>({
        url: `${WareHoseEnum.ENTRY_NO_ORDER_DETAIL}?${qs.stringify(data)}`
    });
}

 //无单入库-列表
 export function getNoOrderPage(data: any = {}) {
    return msiRequest.get<ResultType<any>>({
      url: `${WareHoseEnum.ENTRY_NO_ORDER_PAGE}?${qs.stringify(data)}`
    });
}

//无单入库 -- 新增
export function addEntryNoOrder(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.ENTRY_NO_ORDER_ADD,
        data
    })
}

//无单入库 -- 编辑
export function editEntryNoOrder(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.ENTRY_NO_ORDER_EDIT,
        data
    })
}

//无单入库 -- 删除
export function delEntryNOrder(data: delType) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.ENTRY_NO_ORDER_DEL,
        data
    })
}


//无单入库 -- 获取物料列表
export function getEntryMaterial(data: any={}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.ENTRY_NO_ORDER_MATERIAL,
        data
    })
}

// ----------------------------------------------------

 //无单出入库_无单出库管理——出库
 export function outerConfirm(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.OUTER_CONFIRM,
        data
    });
}

 //无单出入库_无单出库管理——删除出库单
 export function delOutOrder(data: {orderNo: string[]}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.DEL_OUT_ORDER,
        data
    });
}

 //无单出入库_无单出库管理——出库单列表
export function getOutPage(data: any = {}) {
    return msiRequest.get<ResultType<any>>({
        url: `${WareHoseEnum.OUT_PAGE}?${qs.stringify(data)}`
    });
}

//无单出入库_无单出库管理——出库单详情
export function getOutDetailPage(data: any = {}) {
    return msiRequest.get<ResultType<any>>({
        url: `${WareHoseEnum.OUT_DETAIL_PAGE}?${qs.stringify(data)}`
    });
}


//领用创建出库单
export function getOutReceivePage(data: any = {}) {
    return msiRequest.get<ResultType<any>>({
        url: `${WareHoseEnum.RECEIVE_PAGE}?${qs.stringify(data)}`
    });
}
 
//无单出入库_库存管理——列表
export function getInventoryPage(data: any = {}) {
    return msiRequest.get<ResultType<any>>({
        url: `${WareHoseEnum.INVENTORY_PAGE}?${qs.stringify(data)}`
    });
}

// 无单出入库_库存管理——创建出库单
 export function createNoOrder(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.INVENTORY_CREATE,
        data
    })
}

 
 //订单件入库单 -- 列表
 export function getEntryOrderPage(data: any = {}) {
     return msiRequest.get<ResultType<any>>({
       url: `${WareHoseEnum.ENTRYORDER_PAGE}?${qs.stringify(data)}`
     });
 }
 
 //订单件入库单 -- 新增
 export function addEntryOrder(data: any = {}) {
     return msiRequest.post<ResultType<any>>({
         url: WareHoseEnum.ENTRYORDER_ADD,
         data
     })
 }
 
 //订单件入库单 -- 编辑
 export function editEntryOrder(data: any = {}) {
     return msiRequest.post<ResultType<any>>({
         url: WareHoseEnum.ENTRYORDER_EDIT,
         data
     })
 }
 
 //订单件入库单 -- 删除
 export function delEntryOrder(data: delType) {
     return msiRequest.post<ResultType<any>>({
         url: WareHoseEnum.ENTRYORDER_DELETE,
         data
     })
 }
 //AGV站点管理
 export function agvPage(data: any = {}) {
    return msiRequest.get<ResultType<any>>({
      url: `${WareHoseEnum.AGV_PAGE}?${qs.stringify(data)}`
    });
}
export function addagvOrder(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.AGV_ADD,
        data
    })
}
export function delagvOrder(data: delType) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.AGV_EDIT,
        data
    })
}
export function editagvOrder(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.AGV_DELETE,
        data
    })
} 
 //AGV任务
 export function wareagvPage(data: any = {}) {
    return msiRequest.get<ResultType<any>>({
      url: `${WareHoseEnum.WareAGV_PAGE}?${qs.stringify(data)}`
    });
}
// export function wareagvfinshed(data: any = {}) {
//     return msiRequest.get<ResultType<any>>({
//       url: `${WareHoseEnum.WareAGV_update}?${qs.stringify(data)}`
//     });
// }
export function wareagvfinshed(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.WareAGV_update,
        data
    })
}
export function wareagvdelete(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: WareHoseEnum.WareAGV_delete,
        data
    })
}
